import React, { useState, useEffect } from 'react';
import { MessageCircle, X, Phone, Sparkles } from 'lucide-react';
import { COMPANY } from '../../mock';
import { Button } from '../ui/button';

export default function WhatsAppFloat() {
  const [open, setOpen] = useState(false);
  const [showCallout, setShowCallout] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowCallout(true), 3500);
    const t2 = setTimeout(() => setShowCallout(false), 14000);
    return () => { clearTimeout(t); clearTimeout(t2); };
  }, []);

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3">
      {/* Get Free Quote button (mobile only) */}
      <div className="md:hidden relative group">
        <Button 
          onClick={() => window.dispatchEvent(new CustomEvent('mct:openEnquiry'))}
          className="w-12 h-12 rounded-full bg-brand-orange text-white shadow-card flex items-center justify-center animate-bounce-subtle p-0"
        >
          <Sparkles size={22} />
        </Button>
        <div className="absolute -top-0.5 -right-0.5 w-3.5 h-3.5 bg-red-500 rounded-full border-2 border-white animate-ping" />
        {/* Label for Quote button */}
        <div className="absolute right-14 top-1/2 -translate-y-1/2 bg-brand-blue text-white text-[10px] font-bold px-2 py-1 rounded-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">FREE QUOTE</div>
      </div>

      {/* Phone button (small) */}
      <a href={`tel:${COMPANY.phone}`} className="w-12 h-12 rounded-full bg-brand-blue text-white shadow-card flex items-center justify-center hover:scale-110 transition-transform" aria-label="call">
        <Phone size={20} />
      </a>

      {/* Callout bubble */}
      {showCallout && !open && (
        <div className="relative bg-white shadow-premium rounded-2xl px-4 py-3 max-w-[260px] animate-fade-up">
          <button onClick={() => setShowCallout(false)} className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-brand-blue text-white flex items-center justify-center"><X size={11} /></button>
          <div className="text-[13px] font-semibold text-brand-blue">👋 Need a custom quote?</div>
          <div className="text-[12px] text-brand-blue/70 mt-0.5">Chat with our travel expert - reply in 5 mins.</div>
        </div>
      )}

      {/* Expanded card */}
      {open && (
        <div className="bg-white shadow-premium rounded-2xl w-[min(300px,calc(100vw-2.5rem))] overflow-hidden animate-fade-up">
          <div className="bg-[#075E54] text-white p-4 flex items-center gap-3">
            <div className="w-11 h-11 rounded-full bg-white/20 flex items-center justify-center"><MessageCircle size={22} /></div>
            <div>
              <div className="font-semibold text-sm">Mountains Chain Travel</div>
              <div className="text-[11px] opacity-80">Typically replies in 5 mins</div>
            </div>
          </div>
          <div className="p-4 bg-[#ECE5DD]">
            <div className="bg-white rounded-lg rounded-tl-none px-3 py-2 text-[13px] text-brand-blue shadow-sm">
              Hi there! 👋<br/>Tell us your destination & dates - we’ll send your best quote in 5 minutes.
            </div>
          </div>
          <a href={`https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent('Hi Mountains Chain Travel! 👋\n\nI\'d love to plan a trip with you.\n\nPlease share:\n- Available tour packages\n- Pricing options\n- Customizable itineraries\n\nThank you!')}`} target="_blank" rel="noreferrer" className="block bg-[#25D366] text-white text-center py-3 font-semibold text-sm hover:bg-[#1DAE54] transition-colors">
            Start Chat on WhatsApp
          </a>
        </div>
      )}

      <button onClick={() => setOpen(!open)} className="w-14 h-14 rounded-full bg-[#25D366] text-white shadow-glow-orange flex items-center justify-center animate-pulse-soft hover:scale-110 transition-transform" aria-label="whatsapp">
        {open ? <X size={24} /> : <MessageCircle size={26} />}
      </button>
    </div>
  );
}
